<template>


<app-modalData :init = "metaData"  @f="f($event)"   v-if="metaData">

  <div slot="moreFunc">
    {{updaters}}
    <v-btn style="margin:0px" @click="resourcesDeleteSelected()" v-if="modalData.selectedItem == 'non_done' && tasks.task.resources.foundData.selectedIds.length>0"  flat small color="orange"  class="white--text" ><v-icon small left>mdi-delete</v-icon><span style="text-transform:none">Удалить {{tasks.task.resources.foundData.selectedIds.length}}</span> </v-btn>
    <v-btn style="margin:0px" @click="resourcesDeleteSelected1()" v-if="modalData.selectedItem == 'non_done1' && tasks.task.resources.foundData1.selectedIds.length>0"  flat small color="orange"  class="white--text" ><v-icon small left>mdi-delete</v-icon><span style="text-transform:none">Удалить {{tasks.task.resources.foundData1.selectedIds.length}}</span> </v-btn>
    <v-btn style="margin:0px" @click="resourcesDeleteSelectedDone()" v-if="modalData.selectedItem == 'before_done' && tasks.task.resources.foundDataDone.selectedIds.length>0"  flat small color="orange"  class="white--text" ><v-icon small left>mdi-delete</v-icon> <span style="text-transform:none">Удалить {{tasks.task.resources.foundDataDone.selectedIds.length}} </span></v-btn>
    <v-btn style="margin:0px" @click="resourcesDeleteSelectedMinus_traff()" v-if="modalData.selectedItem == 'minus_traff' && tasks.task.resources.foundDataMinus_traff.selectedIds.length>0"  flat small color="orange"  class="white--text" ><v-icon small left>mdi-delete</v-icon> <span style="text-transform:none">Удалить {{tasks.task.resources.foundDataMinus_traff.selectedIds.length}} </span></v-btn>
    <v-btn style="margin:0px" @click="resourcesDeleteSelectedBots()" v-if="modalData.selectedItem == 'bot_filter' && tasks.task.resources.foundDataBots.selectedIds.length>0"  flat small color="orange"  class="white--text" ><v-icon small left>mdi-delete</v-icon> <span style="text-transform:none">Удалить {{tasks.task.resources.foundDataBots.selectedIds.length}} </span></v-btn>

    <v-btn style="margin:0px" @click="deleteAll()" flat  small color="red"  class="white--text" ><span style="text-transform:none">Очистистить все </span></v-btn>
  </div>


  <div slot="operations" style="margin-top:15px;border:solid #E3E4E8 1px;padding:5px;border-radius:3px">

  <div v-if="modalData.selectedItem == 'non_done'">
  <v-textarea  v-model="resources" color="#4A76A8" label="Список IDS через запятую">
  </v-textarea>
  <v-btn  @click="resourcesAdd()" block small color="#4A76A8"  class="white--text" style="text-transform:none">
  <v-icon>mdi-plus</v-icon>
  Добавить ресурсы
  </v-btn>
  </div>

<v-divider  v-if="modalData.selectedItem == 'non_done'"></v-divider>

<v-btn v-if="modalData.selectedItem == 'non_done'" @click="resourcesDeleteAll()" flat block small color="red"  class="white--text" style="text-transform:none">Очистить Входящий трафик </v-btn>
<v-btn v-if="modalData.selectedItem == 'non_done1'" @click="resourcesDeleteAll1()" flat block small color="red"  class="white--text" style="text-transform:none">Очистить Очередь </v-btn>
<v-btn v-if="modalData.selectedItem == 'before_done'" @click="deleteAllDone()"  flat block small color="red"  class="white--text" style="text-transform:none">Очистить обработанные</v-btn>
<v-btn v-if="modalData.selectedItem == 'minus_traff'" @click="deleteAllMinus_traff()"  flat block small color="red"  class="white--text" style="text-transform:none">Очистить исключения</v-btn>
<v-btn v-if="modalData.selectedItem == 'bot_filter'" @click="deleteAllBots()"  flat block small color="red"  class="white--text" style="text-transform:none">Очистить фильтр</v-btn>


<v-btn  @click="resourcesDeleteSrc(modalData.selectedItem)" flat block small color="red"  class="white--text" style="text-transform:none">Очистить источник</v-btn>

<v-dialog v-model="deleteBySrc.modal" width="550" persistent scrollable>
<v-card>
<v-toolbar flat color="red" height="42">
<v-toolbar-title style="color:white">
Удалить источник из:
<span v-if="modalData.selectedItem == 'non_done'">"Трафик"</span>
<span v-if="modalData.selectedItem == 'non_done1'">"Очередь"</span>
<span v-if="modalData.selectedItem == 'before_done'">"Обработанные"</span>
<span v-if="modalData.selectedItem == 'minus_traff'">"Исключения"</span>
<span v-if="modalData.selectedItem == 'bot_filter'">"Фильтр"</span>
</v-toolbar-title>
<v-spacer/>
<v-icon @click="deleteBySrc.modal = false" color="white">mdi-close</v-icon>
</v-toolbar>

<v-card-text>
<h6 style="color:gray"> Обратите внимание, если не указать id источника, то будет удален
весь трафик данного раздела от этого источника. Если ваш источник "Лайк постов" - формат
источника:  wall_123_12 для постов страниц и wall_-123_12 для постов сообществ.
Id источника для типа источника "Подписчик сообществ" - цифровое id сообщества, именно
id, например 458948393.
</h6>

<v-select
label="Выберите тип источника" color="#242F3B"
:items="deleteBySrc.sourceTypes" v-model="deleteBySrc.sourceType">
</v-select>

<div v-if="deleteBySrc.sourceType != '' && deleteBySrc.sourceType != 'withoutScr'">
<v-text-field color="#242F3B" v-model="deleteBySrc.sourceId" label="Укажите id источника, оставьте пустым что бы удалить весь трафик данного типа источника"></v-text-field>
</div>

<v-checkbox color="#242F3B"  hide-details v-model="deleteBySrc.deleteBots">
<span slot="label" style="margin-top:6px;font-size:.9em">Удалить ботов от всех источников</span>
</v-checkbox>
<v-checkbox color="#242F3B"  hide-details v-model="deleteBySrc.saveIds">
<span slot="label" style="margin-top:6px;font-size:.9em">Сохранить удаленные в TXT</span>
</v-checkbox>
</v-card-text>
<v-card-actions>
<v-spacer/>
<v-btn   @click="deleteBySrc.modal = false"  small flat color="#242F3B" style="text-transform:none"  >  Отмена</v-btn>
<v-btn :loading="deleteBySrc.loading"   @click="resourcesDeleteSrcRun(modalData.selectedItem)" small color="red" style="text-transform:none" class="white--text">
<v-icon left>mdi-delete</v-icon> Удалить трафик источника
</v-btn>
</v-card-actions>

</v-card>
</v-dialog>


</div>


</app-modalData>


</template>

<script>
import contentMeneger from './data'
import axios from 'axios'
export default {
props:['tasks'],
data () {
return {
deleteBySrc:{
loading:false,
modal:false,
sourceType:"",
sourceId:"",
deleteBots:false,
saveIds:true,
sourceTypes:[
{text:"Неизвестный источник", value:"withoutScr"},
{text:"Подписчик сообществ", value:"group"},
{text:"Лайк поста", value:"post_like"},
],
},

resources: null,
bl: false,
autoUp : false,

autoUpper  : true  , // помогает обовлять интервал




modalData:{
 sb: {
   snackbar: false,
   color: 'success',
   text: ''
 },
 f: "",
 selectedItem: "non_done",
 selectedTab: "before_done",
   header:{
     text:"",
      icon:"mdi-database",
     icons:[
       {
         name:"mdi-update",
         f:"autoStopper",
       },
       {
         name:"mdi-close",
         f:"close",
       },
     ]
   },
 bar: {
     items:[
       {
          itemName: 'non_done',
          text:'Трафик',
          f: null,
          selectedColor: 'green',
          color: '#4A76A8',
       },
       {
          itemName: 'non_done1',
          text:'Очередь',
          f: null,
          selectedColor: 'green',
          color: '#4A76A8',
       },
       {
          itemName: 'before_done',
          text:'Обработанные',
          f: null,
       },
       {
          itemName: 'minus_traff',
          text:'Исключения',
          f: null,
       },
       {
          itemName: 'bot_filter',
          text:'Боты',
          f: null,
       },

     ],
     status: ""
   },
 content:{
   type:'pages',
     items:{

         non_done:{
           foundData: {},
           meneger:{}
         },
         non_done1:{
           foundData: {},
           meneger:{}
         },
         before_done:{
           foundData: {},
           meneger:{}
         },
         minus_traff:{
           foundData: {},
           meneger:{}
         },
         bot_filter:{
           foundData: {},
           meneger:{}
         },

     },
   },


 operations:{

 }

},

    }
  },
computed: {

// данная штука следить в задание есть ли изменение временной метки что бы обновить ресурсы
updaters(){
  if(this.tasks.task.startUpdateRes){
    this.getNewdata()
    return ''
  }
},

metaData(){
  if(this.tasks.modals.resources){

  let   dataInf =  contentMeneger.ttr()
    this.modalData.header.text = this.tasks.task.info.name
    this.modalData.content.type = this.tasks.task.info.content_type

    dataInf.сontentMenegment.contentInfo.type = this.tasks.task.info.content_type
    dataInf.сontentMenegmentD.contentInfo.type = this.tasks.task.info.content_type

    dataInf.сontentMenegment.init = this.tasks.task
    this.modalData.content.items.non_done.foundData = this.tasks.task.resources.foundData
    this.modalData.content.items.non_done.meneger = dataInf.сontentMenegment

    dataInf.сontentMenegment1.init = this.tasks.task
    this.modalData.content.items.non_done1.foundData = this.tasks.task.resources.foundData1
    this.modalData.content.items.non_done1.meneger = dataInf.сontentMenegment1

    dataInf.сontentMenegmentD.init = this.tasks.task
    this.modalData.content.items.before_done.foundData = this.tasks.task.resources.foundDataDone
    this.modalData.content.items.before_done.meneger = dataInf.сontentMenegmentD

    dataInf.сontentMenegmentMinus_traff.init = this.tasks.task
    this.modalData.content.items.minus_traff.foundData = this.tasks.task.resources.foundDataMinus_traff
    this.modalData.content.items.minus_traff.meneger = dataInf.сontentMenegmentMinus_traff

    dataInf.сontentMenegmentBots.init = this.tasks.task
    this.modalData.content.items.bot_filter.foundData = this.tasks.task.resources.foundDataBots
    this.modalData.content.items.bot_filter.meneger = dataInf.сontentMenegmentBots

    this.getNewdata()

    return this.modalData
  } else {
    clearTimeout(this.autoUpper)
    return false
  }
  },

},


methods:{
  f(fName){
  eval('this.'+fName+'()')
  },

resourcesDeleteSrc(selectedItem){
this.deleteBySrc.modal = true
},
resourcesDeleteSrcRun(selectedItem){
this.deleteBySrc.loading = true
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/resources_delete_src.php', {
method: 'POST',
data: {
taskId: this.tasks.task.info.task_id,
deleteBySrc: this.deleteBySrc,
traffStatus: selectedItem,
}
})
.then( response => {
if(!this.deleteBySrc.saveIds){
this.deleteBySrc.loading = false
this.deleteBySrc.modal = false
}
let deleted = response.data.deleted
if(this.deleteBySrc.saveIds && response.data.deleted){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/txt/create_txt.php', {
method: 'POST',
responseType: 'file',
data: {
         type : 'pages',   //this.contentMenegment.contentInfo.type
         pattern: '[id],',
         newLines: false,
         ids:  deleted ,
}
})
.then( response => {
this.deleteBySrc.loading = false
this.deleteBySrc.modal = false
const url = window.URL.createObjectURL(new Blob([response.data]));
const link = document.createElement('a');
link.href = url;
link.setAttribute('download', 'deleted_scr_vkplus.txt');
document.body.appendChild(link);
link.click();
})
}
this.getNewdata()
this.modalData.sb.color = "success"
this.modalData.sb.text = response.data.success
this.modalData.sb.snackbar = true
})
},

getNewdata(){
  this.modalData.bar.status = "Выполняется обновление"
        axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/select_resources.php', {
             method: 'POST',
             data: {
               taskId: this.tasks.task.info.task_id
             }
           })
           .then( response => {
             this.modalData.bar.status = ""
                     this.tasks.task.resources.foundData.selector = false
                     this.tasks.task.resources.foundData.foundIds = []
                     this.tasks.task.resources.foundData.displayIds = []
                     this.tasks.task.resources.foundData.selectedIds = []
                     this.tasks.task.resources.foundData.offset = 0
                     this.tasks.task.resources.foundData.selectAll = false

                     this.tasks.task.resources.foundData1.selector = false
                     this.tasks.task.resources.foundData1.foundIds = []
                     this.tasks.task.resources.foundData1.displayIds = []
                     this.tasks.task.resources.foundData1.selectedIds = []
                     this.tasks.task.resources.foundData1.offset = 0
                     this.tasks.task.resources.foundData1.selectAll = false

                     this.tasks.task.resources.foundDataDone.selector = false
                     this.tasks.task.resources.foundDataDone.foundIds = []
                     this.tasks.task.resources.foundDataDone.displayIds = []
                     this.tasks.task.resources.foundDataDone.selectedIds = []
                     this.tasks.task.resources.foundDataDone.offset = 0
                     this.tasks.task.resources.foundDataDone.selectAll = false

this.tasks.task.resources.foundDataMinus_traff.selector = false
this.tasks.task.resources.foundDataMinus_traff.foundIds = []
this.tasks.task.resources.foundDataMinus_traff.displayIds = []
this.tasks.task.resources.foundDataMinus_traff.selectedIds = []
this.tasks.task.resources.foundDataMinus_traff.offset = 0
this.tasks.task.resources.foundDataMinus_traff.selectAll = false

                     this.tasks.task.resources.foundDataBots.selector = false
                     this.tasks.task.resources.foundDataBots.foundIds = []
                     this.tasks.task.resources.foundDataBots.displayIds = []
                     this.tasks.task.resources.foundDataBots.selectedIds = []
                     this.tasks.task.resources.foundDataBots.offset = 0
                     this.tasks.task.resources.foundDataBots.selectAll = false

              if(response.data.resurces !== '') { this.tasks.task.resources.foundData.foundIds = response.data.resurces.split(',') }
              if(response.data.resurces1 !== '') { this.tasks.task.resources.foundData1.foundIds = response.data.resurces1.split(',') }
              if(response.data.before_done !== '') { this.tasks.task.resources.foundDataDone.foundIds = response.data.before_done.split(',') }
              if(response.data.minus_traff !== '') { this.tasks.task.resources.foundDataMinus_traff.foundIds = response.data.minus_traff.split(',') }
              if(response.data.bots !== '') { this.tasks.task.resources.foundDataBots.foundIds = response.data.bots.split(',') }
        })},



 autoStopper(){
   this.autoUp = !this.autoUp
   if(this.autoUp){
     this.modalData.header.icons[0].name = 'mdi-stop-circle'
     this.autoUp = true
     this.updater()
   } else {
     this.modalData.header.icons[0].name = 'mdi-update'
     this.autoUp = false
     this.autoUpper = false
   }
 },
updater(){
    if(this.autoUp){
    this.modalData.bar.status = "Выполняется обновление"
    }
          axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/select_resources.php', {
               method: 'POST',
               data: {
                 taskId: this.tasks.task.info.task_id
               }
             })
             .then( response => {
               if(this.autoUp){
               this.modalData.bar.status = ""
                       this.tasks.task.resources.foundData.selector = false
                       this.tasks.task.resources.foundData.foundIds = []
                       this.tasks.task.resources.foundData.displayIds = []
                       this.tasks.task.resources.foundData.selectedIds = []
                       this.tasks.task.resources.foundData.offset = 0
                       this.tasks.task.resources.foundData.selectAll = false

                       this.tasks.task.resources.foundData1.selector = false
                       this.tasks.task.resources.foundData1.foundIds = []
                       this.tasks.task.resources.foundData1.displayIds = []
                       this.tasks.task.resources.foundData1.selectedIds = []
                       this.tasks.task.resources.foundData1.offset = 0
                       this.tasks.task.resources.foundData1.selectAll = false

                       this.tasks.task.resources.foundDataDone.selector = false
                       this.tasks.task.resources.foundDataDone.foundIds = []
                       this.tasks.task.resources.foundDataDone.displayIds = []
                       this.tasks.task.resources.foundDataDone.selectedIds = []
                       this.tasks.task.resources.foundDataDone.offset = 0
                       this.tasks.task.resources.foundDataDone.selectAll = false

                       this.tasks.task.resources.foundDataMinus_traff.selector = false
                       this.tasks.task.resources.foundDataMinus_traff.foundIds = []
                       this.tasks.task.resources.foundDataMinus_traff.displayIds = []
                       this.tasks.task.resources.foundDataMinus_traff.selectedIds = []
                       this.tasks.task.resources.foundDataMinus_traff.offset = 0
                       this.tasks.task.resources.foundDataMinus_traff.selectAll = false

                       this.tasks.task.resources.foundDataBots.selector = false
                       this.tasks.task.resources.foundDataBots.foundIds = []
                       this.tasks.task.resources.foundDataBots.displayIds = []
                       this.tasks.task.resources.foundDataBots.selectedIds = []
                       this.tasks.task.resources.foundDataBots.offset = 0
                       this.tasks.task.resources.foundDataBots.selectAll = false

                if(response.data.resurces !== '') { this.tasks.task.resources.foundData.foundIds = response.data.resurces.split(',') }
                if(response.data.resurces1 !== '') { this.tasks.task.resources.foundData1.foundIds = response.data.resurces1.split(',') }
                if(response.data.before_done !== '') { this.tasks.task.resources.foundDataDone.foundIds = response.data.before_done.split(',') }
                if(response.data.minus_traff !== '') { this.tasks.task.resources.foundDataMinus_traff.foundIds = response.data.minus_traff.split(',') }
                if(response.data.bots !== '') { this.tasks.task.resources.foundDataBots.foundIds = response.data.bots.split(',') }
              } else this.modalData.bar.status = ""

              if(this.tasks.modals.resources && this.autoUp){
              this.autoUpper =    setTimeout( ()=>{this.updater()}, 5000)
            } else {
              clearTimeout(this.autoUpper)
            }


          })
},

  resourcesAdd(){

  if(this.resources == null){
    this.modalData.sb.color = "error"
    this.modalData.sb.text = "список IDS пуст"
     this.modalData.sb.snackbar = true
  } else {
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/add_resourcess.php', {
         method: 'POST',
         data: {
           taskIds:  [this.tasks.task.info.task_id],
           data:  this.resources.split(','),
           frontEnd: this.tasks.task.info.task_id
         }
       })
       .then( response => {
          this.getNewdata()
          this.modalData.sb.color = "success"
          this.modalData.sb.text = response.data.success
          this.modalData.sb.snackbar = true
          this.tasks.task.resources.foundData.foundIds = this.tasks.task.resources.foundData.foundIds.concat(response.data.ids.split(','))
          this.resources = null

       })

  }


  },

    deleteAll(){
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/delete_resourcess.php', {
         method: 'POST',
         data: {
           taskIds:   this.tasks.task.info.task_id ,
           deleteAll:  1,

         }
       })
       .then( response => {

  if(response.data.success == 'Список ресурсов очищен'){
    this.tasks.task.resources.foundData.selector = false
    this.tasks.task.resources.foundData.foundIds = []
    this.tasks.task.resources.foundData.displayIds = []
    this.tasks.task.resources.foundData.selectedIds = []
    this.tasks.task.resources.foundData.offset = 0
    this.tasks.task.resources.foundData.selectAll = false

    this.tasks.task.resources.foundData1.selector = false
    this.tasks.task.resources.foundData1.foundIds = []
    this.tasks.task.resources.foundData1.displayIds = []
    this.tasks.task.resources.foundData1.selectedIds = []
    this.tasks.task.resources.foundData1.offset = 0
    this.tasks.task.resources.foundData1.selectAll = false


    this.tasks.task.resources.foundDataDone.selector = false
    this.tasks.task.resources.foundDataDone.foundIds = []
    this.tasks.task.resources.foundDataDone.displayIds = []
    this.tasks.task.resources.foundDataDone.selectedIds = []
    this.tasks.task.resources.foundDataDone.offset = 0
    this.tasks.task.resources.foundDataDone.selectAll = false

    this.tasks.task.resources.foundDataMinus_traff.selector = false
    this.tasks.task.resources.foundDataMinus_traff.foundIds = []
    this.tasks.task.resources.foundDataMinus_traff.displayIds = []
    this.tasks.task.resources.foundDataMinus_traff.selectedIds = []
    this.tasks.task.resources.foundDataMinus_traff.offset = 0
    this.tasks.task.resources.foundDataMinus_traff.selectAll = false

    this.tasks.task.resources.foundDataBots.selector = false
    this.tasks.task.resources.foundDataBots.foundIds = []
    this.tasks.task.resources.foundDataBots.displayIds = []
    this.tasks.task.resources.foundDataBots.selectedIds = []
    this.tasks.task.resources.foundDataBots.offset = 0
    this.tasks.task.resources.foundDataBots.selectAll = false

    //this.init.loadingMore = false
     this.modalData.sb.color = "success"
     this.modalData.sb.text = response.data.success
     this.modalData.sb.snackbar = true
     this.resources = null


  }


       })

  },
  resourcesDeleteAll(){
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/delete_resourcess.php', {
         method: 'POST',
         data: {
           taskIds:   this.tasks.task.info.task_id ,
           deleteResourcesAll:  1,

         }
       })
       .then( response => {

  if(response.data.success == 'Список ресурсов очищен'){
    this.tasks.task.resources.foundData.selector = false
    this.tasks.task.resources.foundData.foundIds = []
    this.tasks.task.resources.foundData.displayIds = []
    this.tasks.task.resources.foundData.selectedIds = []
    this.tasks.task.resources.foundData.offset = 0
    this.tasks.task.resources.foundData.selectAll = false


    //this.init.loadingMore = false
     this.modalData.sb.color = "success"
     this.modalData.sb.text = response.data.success
     this.modalData.sb.snackbar = true
     this.resources = null


  }


       })

  },

  resourcesDeleteAll1(){
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/delete_resourcess.php', {
         method: 'POST',
         data: {
           taskIds:   this.tasks.task.info.task_id ,
           deleteResourcesAll1:  1,

         }
       })
       .then( response => {

  if(response.data.success == 'Список ресурсов очищен'){
    this.tasks.task.resources.foundData1.selector = false
    this.tasks.task.resources.foundData1.foundIds = []
    this.tasks.task.resources.foundData1.displayIds = []
    this.tasks.task.resources.foundData1.selectedIds = []
    this.tasks.task.resources.foundData1.offset = 0
    this.tasks.task.resources.foundData1.selectAll = false


    //this.init.loadingMore = false
     this.modalData.sb.color = "success"
     this.modalData.sb.text = response.data.success
     this.modalData.sb.snackbar = true
     this.resources = null


  }


       })

  },


  deleteAllDone(){
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/delete_resourcess.php', {
       method: 'POST',
       data: {
         taskIds:   this.tasks.task.info.task_id ,
         deleteResourcesAllDone:  1,

       }
     })
     .then( response => {

if(response.data.success == 'Список обработанных очищен'){

  this.tasks.task.resources.foundDataDone.selector = false
  this.tasks.task.resources.foundDataDone.foundIds = []
  this.tasks.task.resources.foundDataDone.displayIds = []
  this.tasks.task.resources.foundDataDone.selectedIds = []
  this.tasks.task.resources.foundDataDone.offset = 0
  this.tasks.task.resources.foundDataDone.selectAll = false

  //this.init.loadingMore = false
   this.modalData.sb.color = "success"
   this.modalData.sb.text = response.data.success
   this.modalData.sb.snackbar = true
   this.resources = null


}


     })

},


deleteAllMinus_traff(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/delete_resourcess.php', {
method: 'POST',
data: {
taskIds:   this.tasks.task.info.task_id ,
deleteAllMinus_traff:  1,
}
})
.then( response => {
if(response.data.success == 'Список исключений очищен'){
this.tasks.task.resources.foundDataMinus_traff.selector = false
this.tasks.task.resources.foundDataMinus_traff.foundIds = []
this.tasks.task.resources.foundDataMinus_traff.displayIds = []
this.tasks.task.resources.foundDataMinus_traff.selectedIds = []
this.tasks.task.resources.foundDataMinus_traff.offset = 0
this.tasks.task.resources.foundDataMinus_traff.selectAll = false
//this.init.loadingMore = false
 this.modalData.sb.color = "success"
 this.modalData.sb.text = response.data.success
 this.modalData.sb.snackbar = true
 this.resources = null
}
})

},

deleteAllBots(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/delete_resourcess.php', {
     method: 'POST',
     data: {
       taskIds:   this.tasks.task.info.task_id ,
       deleteAllBots:  1,

     }
   })
   .then( response => {

if(response.data.success == 'Список ботов очищен'){

this.tasks.task.resources.foundDataBots.selector = false
this.tasks.task.resources.foundDataBots.foundIds = []
this.tasks.task.resources.foundDataBots.displayIds = []
this.tasks.task.resources.foundDataBots.selectedIds = []
this.tasks.task.resources.foundDataBots.offset = 0
this.tasks.task.resources.foundDataBots.selectAll = false

//this.init.loadingMore = false
 this.modalData.sb.color = "success"
 this.modalData.sb.text = response.data.success
 this.modalData.sb.snackbar = true
 this.resources = null


}


   })

},



resourcesDeleteSelected(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/delete_resourcess.php', {
method: 'POST',
data: {
taskIds:   this.tasks.task.info.task_id ,
deleteSelected :  1,
ids : this.tasks.task.resources.foundData.selectedIds
}
})
.then( response => {
if(response.data.success == "Список (Входящий трафик) изменен"){
     this.getNewdata()
     this.modalData.sb.color = "success"
     this.modalData.sb.text = response.data.success
     this.modalData.sb.snackbar = true
     this.resources = ""
  }
  })
  },

  resourcesDeleteSelected1(){
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/delete_resourcess.php', {
  method: 'POST',
  data: {
  taskIds:   this.tasks.task.info.task_id ,
  deleteSelected1 :  1,
  ids : this.tasks.task.resources.foundData1.selectedIds
  }
  })
  .then( response => {
  if(response.data.success == "Список (в очереди) изменен"){
       this.getNewdata()
       this.modalData.sb.color = "success"
       this.modalData.sb.text = response.data.success
       this.modalData.sb.snackbar = true
       this.resources = ""
    }
    })
    },

  resourcesDeleteSelectedDone(){
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/delete_resourcess.php', {
         method: 'POST',
         data: {
           taskIds:   this.tasks.task.info.task_id ,
           deleteSelectedDone :  1,
           ids : this.tasks.task.resources.foundDataDone.selectedIds
         }
       })
       .then( response => {
  if(response.data.success == "Список (Обработанные) изменен"){
     this.getNewdata()
     this.modalData.sb.color = "success"
     this.modalData.sb.text = response.data.success
     this.modalData.sb.snackbar = true
     this.resources = ""
  }


       })




  },


resourcesDeleteSelectedMinus_traff(){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/delete_resourcess.php', {
method: 'POST',
data: {
taskIds:   this.tasks.task.info.task_id ,
deleteSelectedMinus_traff :  1,
ids : this.tasks.task.resources.foundDataMinus_traff.selectedIds
}
})
.then( response => {
if(response.data.success == "Список (Исключения) изменен"){
     this.getNewdata()
     this.modalData.sb.color = "success"
     this.modalData.sb.text = response.data.success
     this.modalData.sb.snackbar = true
     this.resources = ""
}
})
},

  resourcesDeleteSelectedBots(){
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/delete_resourcess.php', {
  method: 'POST',
  data: {
  taskIds:   this.tasks.task.info.task_id ,
  deleteSelectedBots :  1,
  ids : this.tasks.task.resources.foundDataBots.selectedIds
  }
  })
  .then( response => {
  if(response.data.success == "Список (Бот фильтр) изменен"){
       this.getNewdata()
       this.modalData.sb.color = "success"
       this.modalData.sb.text = response.data.success
       this.modalData.sb.snackbar = true
       this.resources = ""
    }
    })
    },

  close(){
    this.$router.go()
    //this.tasks.modals.resources = false
    //this.modalData.header.icons[0].name =  'mdi-update'
  },


},



beforeDestroy(){

}

}
</script>
